import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "chevrons-up-down-16-negative", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "#C00", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m5 10 3 3 3-3M5 6l3-3 3 3" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
